import { render, staticRenderFns } from "./Products.vue?vue&type=template&id=2dcca538&scoped=true"
import script from "./Products.vue?vue&type=script&lang=js"
export * from "./Products.vue?vue&type=script&lang=js"
import style0 from "./Products.vue?vue&type=style&index=0&id=2dcca538&prod&lang=scss&scoped=true"
import style1 from "./Products.vue?vue&type=style&index=1&id=2dcca538&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dcca538",
  null
  
)

export default component.exports